// extracted by mini-css-extract-plugin
export default {"block":"WhiteEmojiCard_block__n4ddB","icon":"WhiteEmojiCard_icon__lyrMw"};